module.exports = __webpack_public_path__ + "static/media/hurricane-icon.780692af.svg";